<template>
  <img :src="imageUrl"  @load="onImageLoad()"/>
  <div class="loader" v-if="isLoading" ></div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    imageUrl: String,
  },
  setup() {
    const isLoading = ref<boolean>(true);

    const onImageLoad = () => {
      isLoading.value = false;
    };

    return {
      isLoading,
      onImageLoad,
    };
  },
});
</script>


<style lang="scss">
    .loadingImageContainer{
        position: relative;
        .loader{
            position: absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);z-index: 999;
        }
    }
</style>